import { render, staticRenderFns } from "./JobDeliverableManagement.vue?vue&type=template&id=82d2def0&scoped=true"
import script from "./JobDeliverableManagement.vue?vue&type=script&lang=js"
export * from "./JobDeliverableManagement.vue?vue&type=script&lang=js"
import style0 from "./JobDeliverableManagement.vue?vue&type=style&index=0&id=82d2def0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d2def0",
  null
  
)

export default component.exports